import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import api, { formatApiErrorDetail } from "../../lib/api";

export function NewNewsletterDialog({ open, onOpenChange, location, emails, onCreated }) {
  const [source, setSource] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const sources = useMemo(() => [
    ...emails.filter((e) => e.state === "template").map((e) => ({ ...e, group: "Templates" })),
    ...emails.filter((e) => e.state === "sent").slice(0, 30).map((e) => ({ ...e, group: "Recent emails" })),
  ], [emails]);

  const pick = (e) => {
    setSource(e.id);
    setName(e.name.replace(/^TEMPLATE:\s*/i, "").replace(/LOCATION/g, location).replace(/DATE|MONTH\/YEAR/g, new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })));
  };
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/newsletters/emails", { source_id: source, location, name });
      toast.success("Draft created in HubSpot");
      onOpenChange(false); setSource(""); setName("");
      onCreated(data.id);
    } catch (e) { toast.error("Couldn't create draft", { description: formatApiErrorDetail(e.response?.data?.detail) }); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-brand-page" data-testid="nl-new-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-normal">New newsletter · {location}</DialogTitle>
          <DialogDescription>Start from a template or a past email. It'll be sent to {location}'s list only.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[50vh] overflow-y-auto border border-brand-border rounded-md divide-y divide-brand-border">
          {["Templates", "Recent emails"].map((g) => (
            <div key={g}>
              <p className="px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-brand-tertiary bg-brand-hover sticky top-0">{g}</p>
              {sources.filter((s) => s.group === g).map((s) => (
                <button key={s.id} onClick={() => pick(s)} data-testid={`nl-source-${s.id}`}
                  className={`w-full text-left px-3 py-2.5 transition-colors ${source === s.id ? "bg-brand-primary/10" : "hover:bg-brand-hover"}`}>
                  <p className="text-sm text-brand-ink truncate">{s.name}</p>
                  <p className="text-[11px] text-brand-tertiary truncate">{s.subject}</p>
                </button>
              ))}
            </div>
          ))}
        </div>
        <label className="block">
          <span className="text-xs text-brand-muted">Internal name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} data-testid="nl-new-name" className="mt-1 w-full bg-brand-surface border border-brand-border rounded-md px-3 py-2 text-sm" />
        </label>
        <div className="flex justify-end">
          <button onClick={create} disabled={!source || !name.trim() || busy} data-testid="nl-new-create" className="rounded-md bg-brand-ink text-brand-page px-4 py-2 text-sm hover:bg-brand-primary disabled:opacity-50">{busy ? "Creating…" : "Create draft"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
